<template>
  <td :class="{system: code.type === 'system', isExist: isExist}">
    <span v-if="code.type === 'system'" class="badge">SYSTEM</span>
    <span v-else-if="code.type === 'SHOP_ITEM_TYPE'" class="badge">SHOP</span>
    <span v-else-if="code.type === 'COLLECTION_ITEM_TYPE'" class="badge">COLLECTION</span>
    <input type="text" class="input"
      :disabled="code.type === 'system'"
      @focus="onFocus = true"
      @blur="onFocus = false"
      v-model="code.label" />
    <p v-if="isExist && onFocus" class="colorRed mt5">{{locale.admin_code_exist}}</p>
    <div v-if="code.type !== 'system'" class="btns">
      <button class="btn btnRed sizeXs btnDel" @click="onOpenDelete">{{locale.delete}}</button>
    </div>
    <Delete
      v-if="layer"
      :locale="locale"
      @close="onCloseDelete"
      @delete="del(code)" />
  </td>
</template>

<script>
import Delete from '@/components/Admin/CodeDelete.vue'

export default {
  name: 'CodeItem',
  props: [
    'locale',
    'existCode',
    'code'
  ],
  components: {
    Delete
  },
  computed: {
    isExist () {
      const label = this.code.label
      return this.existCode === label
    }
  },
  data () {
    return {
      onFocus: false,
      layer: false
    }
  },
  methods: {
    del (data) {
      this.$emit('delItem', data)
    },
    onOpenDelete () {
      this.layer = true
    },
    onCloseDelete () {
      this.layer = false
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  position: relative;
  &:not(.system) {
    background-color: $color-white !important;
  }
  &.system {
    background-color: $bg-default;
    cursor: not-allowed;
    .input {
      padding-left: 0;
      opacity: 0.75;
    }
  }
  &.isExist .input {
    color: $color-red;
    opacity: 0.7;
  }
  .input {
    width: 50%;
    min-height: 0;
    padding: 0.5em 1em;
    border-color: transparent;
    background-color: transparent;
    opacity: 0.5;
    &:focus {
      opacity: 1;
      border-color: $color-lgrey2;
    }
  }
  .btns {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translate(0, -50%);
    .btn {
      margin-left: 5px;
    }
  }
}
.badge {
  display: inline-block;
  margin-right: 0.6em;
  padding: 2px 8px;
  font-size: 12px;
  color: $color-white;
  vertical-align: middle;
  border-radius: 20px;
  background-color: $color-grey;
  opacity: 0.6;
}
</style>
